import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-header-cartera-pacientes',
  templateUrl: './header-cartera-pacientes.component.html',
  styleUrls: ['./header-cartera-pacientes.component.css']
})
export class HeaderCarteraPacientesComponent implements OnInit {

  fechaInicial: string;
  fechaFinal: string;

  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() download: EventEmitter<any>;

  constructor() {
    this.filtrosSeleccionados = new EventEmitter();
    this.download = new EventEmitter();
  }

  ngOnInit() {
  }

  onGenerar() {
    this.filtrosSeleccionados.emit({
      fechaInicial : this.fechaInicial,
      fechaFinal : this.fechaFinal
    });
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('cartera-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <!doctype html>
       <html lang="es">
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
            integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );

    popupWin.document.close();
  }


  onDescargar() {
    this.download.emit();
  }

}
